var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center bg-auth",class:_vm.isAuthUrl ? 'border-top border-top-2 border-primary' : '',attrs:{"id":"app"}},[_c('router-view'),_c('vue-progress-bar'),_c('modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }